import { AppRouteConfig, breadcrumbs } from '..';

export enum FormsRouteName {
	forms = 'Forms',
	draftList = 'FormDraftList',
	pendingList = 'PendingList',
	publicList = 'PublicList',
	publicFormDetails = 'PublicFormDetails',
	viewForm = 'ViewForm',
	newForm = 'NewForm',
	editForm = 'EditForm',
	editFormCustomFields = 'EditFormCustomFields',
}

export function formsRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'draft',
			name: FormsRouteName.draftList,
			component: () => import('../../views/form/DraftTemplateList.vue'),
			meta: {
				breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('formDraft')],
				caslSubject: 'forms.draft',
				caslAction: 'view',
			},
		},
		{
			path: 'pending',
			name: FormsRouteName.pendingList,
			component: () => import('../../views/form/SubmittedTemplateList.vue'),
			meta: {
				breadcrumbs: [breadcrumbs.get('home'), breadcrumbs.get('formPending')],
				caslSubject: 'forms.submitted',
				caslAction: 'view',
			},
		},
		{
			path: 'public',
			component: { render: c => c('router-view') },
			meta: {
				caslSubject: 'forms.published',
				caslAction: 'view',
			},
			children: [
				{
					path: '',
					name: FormsRouteName.publicList,
					component: () => import('../../views/form/PublicFormList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('formPublic'),
						],
					},
				},
				{
					path: ':id',
					name: FormsRouteName.publicFormDetails,
					component: () => import('../../views/form/PublicForm.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('formPublic'),
							breadcrumbs.get('formPreview'),
						],
					},
				},
			],
		},
		{
			path: ':id',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: FormsRouteName.viewForm,
					component: () => import('../../views/form/FormView.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('formDraft'),
							breadcrumbs.get('formPreview'),
						],
						caslSubject: 'forms.draft',
						caslAction: 'view',
						dynamicFrom: 1,
					},
				},
				{
					path: 'edit',
					component: { render: c => c('router-view') },
					children: [
						{
							path: '',
							name: FormsRouteName.editForm,
							component: () => import('../../views/form/FormEdit.vue'),
							meta: {
								breadcrumbs: [
									breadcrumbs.get('home'),
									breadcrumbs.get('formDraft'),
									breadcrumbs.get('formDetails'),
								],
								caslSubject: 'forms.draft',
								caslAction: 'edit',
							},
						},
						{
							path: 'preview',
							name: FormsRouteName.editForm,
							component: () => import('../../views/form/FormView.vue'),
							meta: {
								breadcrumbs: [
									breadcrumbs.get('home'),
									breadcrumbs.get('formDraft'),
									breadcrumbs.get('formDetails'),
									breadcrumbs.get('formPreview'),
								],
								caslSubject: 'forms.draft',
								caslAction: 'view',
								dynamicFrom: 1,
							},
						},
						{
							path: 'custom-fields',
							name: FormsRouteName.editFormCustomFields,
							component: () => import('../../views/form/CustomFieldsEdit.vue'),
							meta: {
								breadcrumbs: [
									breadcrumbs.get('home'),
									breadcrumbs.get('formAll'),
									breadcrumbs.get('formDetails'),
									breadcrumbs.get('formEditCustomFields'),
								],
								caslSubject: 'forms.draft',
								caslAction: 'edit',
							},
						},
					],
				},
			],
		},
		{
			path: 'new',
			name: FormsRouteName.newForm,
			component: () => import('../../views/form/FormEdit.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('formDraft'),
					breadcrumbs.get('formDetails'),
				],
				caslSubject: 'forms.draft',
				caslAction: 'edit',
			},
		},
	];
}
